import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Regions } from '../models/regions';
import Region from './region';
import { Pages } from '../models/enums';

export default function MarketList() {
    const dispatch = useDispatch();
    const navigation = useNavigation();

    const chooseRegion = (region) => {
        navigation.navigate(Pages.home);
        dispatch({type: 'region', payload: region});
    }

    const app = useSelector((state) => state.app);
    const currentRegion = app.region;

    return (
      <ScrollView style={styles.list}>
        { 
            Regions.getList().map((region) => (
                <TouchableOpacity key={region.code} style={styles.mapTouch} onPress={ () => { chooseRegion(region); }}>
                    <Region region={region} isActive={currentRegion == region.code} />
                </TouchableOpacity>
            ))
        }
      </ScrollView>
    );
  }

const styles = StyleSheet.create({
    list: {
      margin: 5,
      marginBottom: 75
    }
})
